export const removeLoader = function() {
	const $loader = document.querySelector('.loader');
	if ($loader) {
		$loader.remove();
	}
};
